import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export const OpeningHook = () => {
  return <Section variant="navy-light" className="relative" data-id="element-115">
      <FadeIn className="text-center max-w-3xl mx-auto" data-id="element-116">
        <Quote className="w-12 h-12 text-gold/30 mx-auto mb-8 rotate-180" data-id="element-117" />

        <p className="text-xl md:text-3xl font-serif italic leading-relaxed mb-10 text-cream" data-id="element-118">
          "Estás en la cama, el silencio es absoluto, pero tu corazón golpea
          como si estuvieras corriendo un maratón. El aire no llega al fondo de
          tus pulmones y una voz en tu cabeza repite sin parar: '¿Y si algo sale
          mal?'."
        </p>

        <div className="w-24 h-px bg-gold/30 mx-auto mb-10" data-id="element-119"></div>

        <p className="text-lg md:text-xl text-cream-muted leading-relaxed" data-id="element-120">
          No es falta de fe. Es un sistema nervioso atrapado en el modo de
          supervivencia. Y la solución no está en ignorarlo, sino en aplicar la{' '}
          <span className="text-gold font-semibold" data-id="element-121">"Medicina Espiritual"</span>{' '}
          exacta para el síntoma que sientes ahora mismo.
        </p>
      </FadeIn>
    </Section>;
};